import { api } from "@/Shared";

export class MediaService {
    static async deletePropertyMedia(mediaId: string | number): Promise<void> {
        await api.delete(`/properties/medias/${mediaId}`);
    }
}